export { default } from './BadgePurchaseOnline';
